import { IonAvatar } from "@ionic/react";
import { MouseEvent, useState } from "react";

import avatar from "../../assets/avatar.svg";
import "./ProfileImage.css";

export interface Profile {
  url?: string;
}

interface ProfileImageProps {
  profile?: Profile;
  onSelect?: (profile: Profile) => void;
  cssClass?: string;
  animate?: boolean;
}

const ProfileImage: React.FC<ProfileImageProps> = ({
  profile,
  onSelect,
  cssClass,
  animate,
}) => {
  const [animateProfile, setAnimateProfile] = useState(false);

  const handleMouseEnter = (_e: MouseEvent) => {
    setAnimateProfile(true);
  };
  const handleMouseLeave = (_e: MouseEvent) => {
    setAnimateProfile(false);
  };

  return (
    <IonAvatar
      onMouseEnter={animate ? handleMouseEnter : undefined}
      onMouseLeave={animate ? handleMouseLeave : undefined}
      className={
        "profile-image " +
        (cssClass ?? "") +
        (animateProfile ? " profile-image-animate" : "")
      }
      onClick={() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        onSelect && profile && onSelect(profile);
      }}
    >
      <img src={profile?.url ? profile.url : avatar} />
    </IonAvatar>
  );
};

export default ProfileImage;
